import { render, staticRenderFns } from "./ExpenseProfessionalItem.vue?vue&type=template&id=dfdb7e54"
import script from "./ExpenseProfessionalItem.vue?vue&type=script&lang=js"
export * from "./ExpenseProfessionalItem.vue?vue&type=script&lang=js"
import style0 from "./ExpenseProfessionalItem.vue?vue&type=style&index=0&id=dfdb7e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports